import { gql } from 'apollo-boost';

export const serviceByIdQuery = gql`
query serviceById($id: ID!) {
  allServices (filters: {id: $id}) {
    edges {
      node {
        dbId
        portfolios
        name
        description    
        indicators {
          edges {
            node {
              dbId
              name
              stageId
            }
          }
        }
        collections {
          edges {
            node {
              name
              description
              dbId
            }
          }
        }
      }
    }
  }
}
`;
